<template>
  <v-row no-gutters class="fill-height flex-column" style="overflow-y: auto; overflow-x: hidden;">
    <v-col cols="12">
      <card-title-row
        translation-path="sidebar.locks.locksAnalysis"
        :class="{ 'pt-5': !isCardInfoPrint }"
        :has-button="false"
      />
      <locks-analysis-tool />
    </v-col>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
export default {
  name: 'LocksAnalysisInfo',
  components: {
    CardTitleRow: () => import('@/components/CardTitleRow'),
    LocksAnalysisTool: () => import('@/components/LocksAnalysisTool'),
  },
  computed: {
    isCardInfoPrint: get('tools/toolStatus@isCardInfoPrintActive'),
  },
  methods: {
    getCutoffProject: call('locks/getCutoffProject'),
    async init() {
      await this.getCutoffProject();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
